/**
* @desc Auxillary file
* @author Lakshmikanth, Ajil
*/

const PrintLog = (...args) => console.log(...args); 

const ConsoleLog = (process.env.REACT_APP_STAGE === 'production' || process.env.REACT_APP_STAGE === 'uat') ? () => null : PrintLog ;

export default ConsoleLog;


// WEBPACK FOOTER //
// ./src/hoc/ConsoleLog/ConsoleLog.js